import { IApplicationState } from '../../types/redux';
import { connect } from 'react-redux';

import { BIReportsInfo, IBIReportsInfoProps } from '../../components/BIReportsInfo';

export const mapStateToProps = (state: IApplicationState): IBIReportsInfoProps => ({
  videoUrl: state.biReportsVideoUrl.url,
});

export const BIReportsInfoContainer = connect(mapStateToProps)(BIReportsInfo);
